import api from '../api';
import { FC, ReactNode, createContext, useState } from 'react';
import { CreateQuestion, Question, Questionnaire } from '../api/apiTypes';

interface AppContextType {
  getCurrentQuestionnaire: () => Promise<void>;
  currentQuestionnaire?: Questionnaire;
  getCurrentQuestionnaireAnswers: () => Promise<void>;
  currentQuestionnaireAnswers?: Questionnaire;
  createQuestion: (question: CreateQuestion) => Promise<void>;
  getQuestionnaires: () => Promise<Questionnaire[]>;
  questionnaires?: Questionnaire[];
}

export const AppContext = createContext({} as AppContextType);
export const AppContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentQuestionnaire, setCurrentQuestionnaire] = useState<Questionnaire | undefined>(undefined);
  const [currentQuestionnaireAnswers, setCurrentQuestionnaireAnswers] = useState<Questionnaire | undefined>(undefined);
  const [questionnaires, setQuestionnaires] = useState<Questionnaire[] | undefined>(undefined);
  const getCurrentQuestionnaire = async () => {
    api
      .getCurrentQuestionnaire()
      .then((resp: any) => {
        setCurrentQuestionnaire(resp.data);
      })
      .catch((err: any) => {
        console.error(err);
      });
  };
  const getCurrentQuestionnaireAnswers = async () => {
    api
      .getCurrentQuestionnaireAnswers()
      .then((resp: any) => {
        setCurrentQuestionnaireAnswers(resp.data);
        return resp.data;
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  const getQuestionnaires = async (persist: boolean = false): Promise<Questionnaire[]> => {
    const list = api
      .getAllQuestionnaires()
      .then((resp: { data: Questionnaire[] }) => {
        if (persist)
          setQuestionnaires(resp.data);
        return resp.data;
      })
      .catch((err: any) => {
        console.error(err);
      });

    return list;
  };

  const createQuestion = async (question: CreateQuestion) => {
    api
      .createQuestion(question)
      .then((resp: Question) => {
        if (currentQuestionnaire?.id === resp.questionnaireId) {
          let updatedList = structuredClone(currentQuestionnaire);
          updatedList.questions.push(resp);
          setCurrentQuestionnaire(updatedList);
        }
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  //TODO: Memoize values in an ideal case to avoid re-rendering.
  const contextValues = {
    currentQuestionnaire, getCurrentQuestionnaire,
    currentQuestionnaireAnswers, getCurrentQuestionnaireAnswers,
    createQuestion,
    getQuestionnaires, questionnaires
  };

  return (
    <AppContext.Provider value={contextValues}>{children}</AppContext.Provider>
  );
};